module.exports = __webpack_public_path__ + "static/Circle-badge-d15311637233a0e32c16716c4e778cfe.png";